import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './Terms.scss';

function Terms() {
  return (
    <>
      <Helmet>
        <title>Terms of Use | Valendris</title>
        <meta name="description" content="Terms of use for the Valendris LLC website." />
      </Helmet>
      <section className="terms">
      <div className="terms-container container">
        <h1 className="terms-title">Terms of Use</h1>
        <p className="terms-updated">Last updated: January 2026</p>

        <div className="terms-content">
          <div className="terms-section">
            <h2 className="terms-section-title">Acceptance of Terms</h2>
            <p className="terms-text">
              By accessing and using the Valendris LLC website, you accept and agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use our website.
            </p>
          </div>

          <div className="terms-section">
            <h2 className="terms-section-title">Use of Website</h2>
            <p className="terms-text">
              You may use our website for lawful purposes only. You agree not to use the website in any way that could damage, disable, or impair the site or interfere with any other party's use of the website.
            </p>
          </div>

          <div className="terms-section">
            <h2 className="terms-section-title">Intellectual Property</h2>
            <p className="terms-text">
              All content on this website, including text, graphics, logos, and software, is the property of Valendris LLC and is protected by intellectual property laws. You may not reproduce, distribute, or create derivative works without our written permission.
            </p>
          </div>

          <div className="terms-section">
            <h2 className="terms-section-title">Services</h2>
            <p className="terms-text">
              Information about our services is provided for general informational purposes. Specific terms for any engagement will be established through a separate agreement between Valendris LLC and the client.
            </p>
          </div>

          <div className="terms-section">
            <h2 className="terms-section-title">Limitation of Liability</h2>
            <p className="terms-text">
              Valendris LLC shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of this website. Our liability is limited to the maximum extent permitted by law.
            </p>
          </div>

          <div className="terms-section">
            <h2 className="terms-section-title">Changes to Terms</h2>
            <p className="terms-text">
              We reserve the right to modify these Terms of Use at any time. Changes will be effective immediately upon posting to the website. Your continued use of the website constitutes acceptance of the modified terms.
            </p>
          </div>

          <div className="terms-section">
            <h2 className="terms-section-title">Contact</h2>
            <p className="terms-text">
              If you have questions about these Terms of Use, please{' '}
              <Link to="/contact" className="terms-link">
                contact us
              </Link>.
            </p>
          </div>
        </div>
      </div>
    </section>
    </>
  );
}

export default Terms;
